export default function FinalCTA() {
  return <section style={{
    backgroundColor: 'rgb(255, 252, 247)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'rgb(42, 45, 43)',
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: '96px',
    paddingBottom: '96px',
    position: 'relative',
    overflow: 'hidden'
  }}>
      <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/spa_bg-FPPqL65JPdZuG7KqU6iTxM.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.04,
      zIndex: 0
    }} />
      <div className="page-container" style={{
      position: 'relative',
      zIndex: 1
    }}>
        <div className="flex justify-center">
          <div className="w-full" style={{
          maxWidth: '760px',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          boxShadow: '0px 8px 40px rgba(0,0,0,0.07)',
          padding: '64px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center'
        }}>
            <p style={{
            color: '#C8985C',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '11px',
            fontWeight: '600',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '20px'
          }}>
              IMMEDIATE ONBOARDING
            </p>

            <h2 style={{
            color: 'rgb(31, 58, 46)',
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: '48px',
            fontWeight: '400',
            lineHeight: '60px',
            border: '0px solid oklch(0.69 0.04 165 / 0.25)',
            textAlign: 'center',
            marginBottom: '24px'
          }}>
              Your tables are{' '}
              <em style={{
              color: '#C8985C',
              fontStyle: 'italic'
            }}>waiting</em>.
            </h2>

            <p style={{
            color: 'rgba(42, 45, 43, 0.7)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            border: '0px solid oklch(0.69 0.04 165 / 0.25)',
            textAlign: 'center',
            maxWidth: '420px',
            marginBottom: '32px'
          }}>
              Join PrepayQR in 60 seconds. No application. No commitment. Turn post-massage endorphins into upfront cash today.
            </p>

            <button style={{
            color: 'rgb(255, 255, 255)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '14px',
            fontWeight: '700',
            lineHeight: '20px',
            letterSpacing: '0.7px',
            backgroundColor: 'rgb(31, 58, 46)',
            borderRadius: '9999px',
            border: '0px solid oklch(0.69 0.04 165 / 0.25)',
            padding: '14px 28px',
            textTransform: 'uppercase',
            textAlign: 'center',
            boxShadow: '0px 10px 15px -3px rgba(31,58,46,0.2), 0px 4px 6px -4px rgba(31,58,46,0.2)',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            marginBottom: '20px'
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLButtonElement).style.opacity = '0.9';
            (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.03)';
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLButtonElement).style.opacity = '1';
            (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
          }}>
              START SOFT ENROLLMENT
              <span dangerouslySetInnerHTML={{
              __html: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>`
            }} />
            </button>

            <p style={{
            color: 'rgba(42, 45, 43, 0.5)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '12px',
            fontWeight: '400',
            textAlign: 'center'
          }}>
              PrepayQR. Spa Cash Flow. Guaranteed.
            </p>
          </div>
        </div>
      </div>
    </section>;
}